import React, {useContext, useEffect} from 'react';
import { Button, Dialog, DialogActions, DialogContent, TextField, Accordion, AccordionSummary, AccordionDetails, Typography, Alert } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddBoxIcon from '@mui/icons-material/AddBox';
import DoneAllIcon from '@mui/icons-material/DoneAll';

import Day from './Day';
import UpdateDay from './UpdateDay';

import { FirebaseContext } from '../../Services/firebase'

import { getMenuList } from '../../Utils/getMenuList';

export default function DocumentCreator(props) {

  const MenuStatus = {
    Created: true
  }

  const firebase = useContext(FirebaseContext)

  const [open, setOpen] = React.useState(false);
  const [WarningClose, setWarningClose] = React.useState(false);
  const [WeekState, setWeekState] = React.useState('');
  const [MenuList, setMenuList] = React.useState([]);
  const [Exist, setExist] = React.useState(false);
  const [WillUpdate, setWillUpdate] = React.useState(false);

  useEffect(() => {
    getMenuList(firebase, props.UserSession.uid, setMenuList)
  }, [firebase, props.UserSession.uid])

  const handleClickOpen = () => {
    try {
        if(MenuList.find(element => element === WeekState)) {
            setExist(true)
          } else {
            setExist(false)
          firebase.newMenuWeek(props.UserSession.uid, WeekState, MenuStatus)
          .then(
            setOpen(true)
          )
          .catch(error => {
            alert(error.message)
          })
      }
    }catch(err) {
      alert(err)
    }
  };

  const handleClose = () => {
    setWarningClose(false)
    setOpen(false);
    setMenuList([])
    setWillUpdate(false)
  };

  const handleReturn = () => {
    setWarningClose(false)
  };

  const handleWarningClose = () => {
    setWarningClose(true);
  };

  const handleDeleteMenu = () => {
    try {
      firebase.deleteMenuWeek(props.UserSession.uid, WeekState)
      .then(
        alert(`Le menu de la semaine ${WeekState} à correctement été supprimé`),
        setTimeout(() => {
          window.location.reload()
        }, 1500)
      )
      .catch(error => {
        alert(error.message)
      })
    }catch(err) {
      alert(err)
    }
  }

  const handleNotDeleteMenu = () => {
    setWeekState('')
    setExist(false)
  }

  const handleUpdate = () => {
    setWillUpdate(true)
    setOpen(true)
  }

  const warning = Exist ? 
    <Alert 
      style={{width: "35vw", marginTop: "1vh"}}
      severity="warning" 
      action={
        <>
          <Button size="small" onClick={handleNotDeleteMenu}>Annuler</Button>
          <Button size="small" onClick={handleDeleteMenu}>Supprimer</Button>
          <Button size="small" onClick={handleUpdate}>Modifier</Button>
        </>
        }
      >
        {`Un menu existe déjà pour la semaine ${WeekState}`}
    </Alert> : null

  return (
    <div style={{display: "flex", flexDirection: "row"}}>
      <div style={{display: "flex", flexDirection: "column"}}>
        <TextField required type="text" name="week" label="numéro de semaine" id="week" value={WeekState} onChange={event => setWeekState(event.target.value)} style={{width: "15vw"}} />
        <Button disabled={WeekState === '' ? true : false} variant="outlined" onClick={handleClickOpen} endIcon={<AddBoxIcon />} style={{marginTop: "1vh", width: "15vw"}}>
            Nouveau menu
        </Button>
        {warning}
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth={'xl'}
          size="small"
          scroll={'paper'}
        >
          <DialogContent>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Lundi</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {WillUpdate === true ? 
                  <UpdateDay day={'1'} week={WeekState} uid={props.UserSession.uid}/> :
                  <Day day={'1'} week={WeekState} uid={props.UserSession.uid}/>}
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Mardi</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {WillUpdate === true ? 
                  <UpdateDay day={'2'} week={WeekState} uid={props.UserSession.uid}/> :
                  <Day day={'2'} week={WeekState} uid={props.UserSession.uid}/>}
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Mercredi</Typography>
              </AccordionSummary>
              <AccordionDetails>
              {WillUpdate === true ? 
                  <UpdateDay day={'3'} week={WeekState} uid={props.UserSession.uid}/> :
                  <Day day={'3'} week={WeekState} uid={props.UserSession.uid}/>}
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Jeudi</Typography>
              </AccordionSummary>
              <AccordionDetails>
              {WillUpdate === true ? 
                  <UpdateDay day={'4'} week={WeekState} uid={props.UserSession.uid}/> :
                  <Day day={'4'} week={WeekState} uid={props.UserSession.uid}/>}
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Vendredi</Typography>
              </AccordionSummary>
              <AccordionDetails>
              {WillUpdate === true ? 
                  <UpdateDay day={'5'} week={WeekState} uid={props.UserSession.uid}/> :
                  <Day day={'5'} week={WeekState} uid={props.UserSession.uid}/>}
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Samedi</Typography>
              </AccordionSummary>
              <AccordionDetails>
              {WillUpdate === true ? 
                  <UpdateDay day={'6'} week={WeekState} uid={props.UserSession.uid}/> :
                  <Day day={'6'} week={WeekState} uid={props.UserSession.uid}/>}
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Dimanche</Typography>
              </AccordionSummary>
              <AccordionDetails>
              {WillUpdate === true ? 
                  <UpdateDay day={'7'} week={WeekState} uid={props.UserSession.uid}/> :
                  <Day day={'7'} week={WeekState} uid={props.UserSession.uid}/>}
              </AccordionDetails>
            </Accordion>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleClose} endIcon={<DoneAllIcon />}>Valider</Button>
            <Button variant="outlined" onClick={handleWarningClose} endIcon={<CloseIcon />}>Fermer</Button>
            <Dialog
              open={WarningClose}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth={true}
              maxWidth={'lg'}
              size="small"
            >
              <DialogContent>
                Etes-vous certain de vouloir quitter la création de menu ? Toute donnée non sauvegardé sera perdu.
              </DialogContent>
              <DialogActions>
                <Button variant="outlined" color="success" onClick={handleReturn} >Annuler</Button>
                <Button variant="outlined" color="error" onClick={handleClose} endIcon={<CloseIcon />}>Confirmer</Button>
              </DialogActions>
            </Dialog>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  )
}